var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"no-gutters":""}},[_c('div',{staticStyle:{"width":"max-content"}},[_c('navigation-drawer')],1),_c('div',{staticStyle:{"padding":"50px 40px","position":"relative","width":"calc(100% - 240px)"}},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }